export enum NavVariant {
	DESKTOP = 'desktop',
	MOBILE = 'mobile',
}
